import { FlashList } from "@shopify/flash-list";
import { FlatList } from "react-native";
import React from "react";
import { forwardRef } from "react";

const ListView = React.forwardRef(
    (
        {
            type,
            data,
            renderItem,
            keyExtractor,
            horizontal,
            showsHorizontalScrollIndicator,
            showsVerticalScrollIndicator,
            estimatedItemSize,
            bounces,
            contentContainerStyle,
            style,
            extraData,
            ListEmptyComponent,
            numColumns,
            ListHeaderComponent,
            ListFooterComponent,
            columnWrapperStyle,
            maxToRenderPerBatch,
            getItemLayout,
            onScrollToIndexFailed,
            initialNumToRender,
            onEndReached,
            onEndReachedThreshold,
            keyboardDismissMode,
            keyboardShouldPersistTaps,
            refreshControl,
            scrollEventThrottle,
            onScroll,
            ItemSeparatorComponent,
            scrollEnabled,
        },
        ref
    ) => {
        return type == ListView.Type.Flash ? (
            <FlashList
                data={data}
                ref={ref}
                renderItem={renderItem}
                keyExtractor={keyExtractor}
                horizontal={horizontal}
                showsHorizontalScrollIndicator={showsHorizontalScrollIndicator}
                showsVerticalScrollIndicator={showsVerticalScrollIndicator}
                estimatedItemSize={estimatedItemSize}
                bounces={bounces}
                scrollEnabled={scrollEnabled}
                contentContainerStyle={contentContainerStyle}
                style={style}
                extraData={extraData}
                ItemSeparatorComponent={ItemSeparatorComponent}
                ListEmptyComponent={ListEmptyComponent}
                numColumns={numColumns}
                ListHeaderComponent={ListHeaderComponent}
                ListFooterComponent={ListFooterComponent}
                columnWrapperStyle={columnWrapperStyle} //TODO: We need to check how we can implement / workaround this.
                maxToRenderPerBatch={maxToRenderPerBatch} //TODO: We need to check how we can implement / workaround this.
                getItemLayout={getItemLayout} //TODO: We need to check how we can implement / workaround this.
                onScrollToIndexFailed={onScrollToIndexFailed} //TODO: We need to check how we can implement / workaround this.
                initialNumToRender={initialNumToRender} //TODO: We need to check how we can implement / workaround this.
                onEndReached={onEndReached}
                onEndReachedThreshold={onEndReachedThreshold}
                keyboardDismissMode={keyboardDismissMode}
                keyboardShouldPersistTaps={keyboardShouldPersistTaps}
                refreshControl={refreshControl}
                scrollEventThrottle={scrollEventThrottle}
                onScroll={onScroll}
            />
        ) : (
            <FlatList
                data={data}
                ref={ref}
                renderItem={renderItem}
                keyExtractor={keyExtractor}
                scrollEnabled={scrollEnabled}
                horizontal={horizontal}
                showsHorizontalScrollIndicator={showsHorizontalScrollIndicator}
                showsVerticalScrollIndicator={showsVerticalScrollIndicator}
                estimatedItemSize={estimatedItemSize}
                bounces={bounces}
                ItemSeparatorComponent={ItemSeparatorComponent}
                contentContainerStyle={contentContainerStyle}
                style={style}
                extraData={extraData}
                ListEmptyComponent={ListEmptyComponent}
                numColumns={numColumns}
                ListHeaderComponent={ListHeaderComponent}
                ListFooterComponent={ListFooterComponent}
                columnWrapperStyle={columnWrapperStyle}
                maxToRenderPerBatch={maxToRenderPerBatch}
                getItemLayout={getItemLayout}
                onScrollToIndexFailed={onScrollToIndexFailed}
                initialNumToRender={initialNumToRender}
                onEndReached={onEndReached}
                onEndReachedThreshold={onEndReachedThreshold}
                keyboardDismissMode={keyboardDismissMode}
                keyboardShouldPersistTaps={keyboardShouldPersistTaps}
                refreshControl={refreshControl}
                scrollEventThrottle={scrollEventThrottle}
                onScroll={onScroll}
            />
        );
    }
);

ListView.Type = {
    Flat: "Flat",
    Flash: "Flash",
};

export default ListView;
